import { Injectable } from '@angular/core';

import { Proposition } from './proposition';
import { PROPOSITIONS } from './propositions';
import { MOCKPROPOSITIONS } from './mock-propositions';

@Injectable()
export class PropositionService {

  getProposition(): Promise<Proposition[]> {
    return Promise.resolve(PROPOSITIONS);
  }

  getMockProposition(): Promise<Proposition[]> {
    return Promise.resolve(MOCKPROPOSITIONS);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/value-proposition/propositions/proposition.service.ts